// Category (and tag) API errors carry a machine-readable code (see MikoVault
// main.py's CATEGORY_ERROR_CODES, which the tag write paths share); the
// wording lives in the locale files under categoryManagement.errors.
// Never render the API's `message` field — it is English plain text meant for
// logs. This module stays hook-free, so it returns a key and the component
// translates it.
const KNOWN_CODES = new Set([
  'invalid_expense_category',
  'duplicate_category_name',
  'duplicate_subcategory_name',
  'code_pool_exhausted',
  'category_in_use',
  'subcategory_in_use',
  'system_category_protected',
  'category_not_found',
  'subcategory_not_found',
  'invalid_tag_name',
  'tag_limit_exceeded',
]);

// Returns the i18n key for a structured category error, or null when the
// error is something else and the caller should fall back to its own message.
export const categoryErrorKey = (err) => {
  const detail = err?.response?.data?.detail;
  const code = typeof detail === 'object' ? detail?.code : null;
  return code && KNOWN_CODES.has(code) ? `categoryManagement.errors.${code}` : null;
};
